// WP6-B.5 — Marketing CMS admin API wrapper.
//
// Wraps the backend `/api/admin/marketing/*` endpoints with the same
// function names the ported G4 admin pages (AdminAbout, AdminProjects,
// AdminSiteImages) expect. The pages were ported verbatim from the
// live Studio G4 pod — the only adjustment vs. their original imports
// is `../../lib/api` → `./marketingAdminApi`.
//
// All calls are credentialed (axios sends the admin `lrs_session`
// cookie because this file never crosses origins — same preview host
// for the admin UI and the API).

import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND}/api/admin/marketing`;
const PUBLIC_API = `${BACKEND}/api/public`;

const client = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// ── Projects ──────────────────────────────────────────────────────
export async function adminGetProjects() {
    const { data } = await client.get("/projects");
    return data;
}

export async function adminCreateProject(payload) {
    const { data } = await client.post("/projects", payload);
    return data;
}

export async function adminUpdateProject(id, payload) {
    const { data } = await client.put(`/projects/${id}`, payload);
    return data;
}

export async function adminDeleteProject(id) {
    const { data } = await client.delete(`/projects/${id}`);
    return data;
}

export async function adminUploadProjectImage(id, file) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await axios.post(`${API}/projects/${id}/upload`, fd, {
        withCredentials: true,
        // Axios sets the correct multipart boundary when no header is given.
    });
    return data;
}

export async function adminUploadProjectCover(id, file) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await axios.post(`${API}/projects/${id}/cover`, fd, {
        withCredentials: true,
    });
    return data;
}

// ── About ─────────────────────────────────────────────────────────
export async function adminGetAbout() {
    const { data } = await client.get("/about");
    return data;
}

export async function adminUpdateAbout(payload) {
    const { data } = await client.put("/about", payload);
    return data;
}

// ── Site Images ───────────────────────────────────────────────────
export async function adminGetSiteImages() {
    const { data } = await client.get("/site-images");
    return data;
}

export async function adminUploadSiteImage(slot, file) {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await axios.post(`${API}/site-images/upload/${slot}`, fd, {
        withCredentials: true,
    });
    return data;
}

export async function adminDeleteSiteImage(slot) {
    const { data } = await client.delete(`/site-images/${slot}`);
    return data;
}

// ── Featured projects ─────────────────────────────────────────────
export async function getFeaturedProjects() {
    const { data } = await client.get("/featured-projects");
    return data;
}

export async function adminUpdateFeaturedProjects(project_ids, orientations) {
    const { data } = await client.put("/featured-projects", {
        project_ids,
        orientations,
    });
    return data;
}

// ── File-serve helper ─────────────────────────────────────────────
export function getFileServeUrl(fileId) {
    if (!fileId) return "";
    return `${PUBLIC_API}/files/serve/${fileId}`;
}
